import { useRecoilValue } from 'recoil';

import { DirectTreasuryDetailsModal } from '../../../../../../../../NewApplication/components/DirectTreasuryDetailsModal';
import { useGlobalAssetContext } from '../../../../../contexts';
import { useDirectTreasuryAssetContext } from '../../../../../contexts/products/DirectTreasury';

export const ItemDetails = () => {
  const { selectedTab } = useGlobalAssetContext();
  const { modalOpen, offerSelected, setModalOpen } = useDirectTreasuryAssetContext();

  const marketStatus = useRecoilValue(selectedTab.marketStatusSelector);

  return (
    <DirectTreasuryDetailsModal
      isOpen={modalOpen}
      offer={offerSelected}
      onClose={() => setModalOpen(false)}
      marketStatus={marketStatus.originalData}
    />
  );
};
